<template>
  <div>
    <app-popup :active.sync="isActive" title="Дополнительно" class="employee-devices-additional-settings-popup">
      <div class="employee-devices-additional-settings-popup__show-inactive">
        <label class="employee-devices-additional-settings-popup__show-inactive-label">Показывать неактивные</label>
        <vs-switch class="employee-devices-additional-settings-popup__show-inactive-switch"
                   v-model="showInactiveModel" />
      </div>

      <div class="employee-devices-additional-settings-popup__column-filter">
        <div class="employee-devices-additional-settings-popup__column-filter-title">
          Скрытие/показ колонок
        </div>
        <div class="employee-devices-additional-settings-popup__column-filter-row"
             v-for="(filter,index) in indicationColumnsFilterModel"
             :key="`indication-filter${index}`">
          <vs-checkbox :value="indicationColumnsFilterModel[index]" @input="updateColumnFilter(index, $event)">
            {{ findIndicationColumnByField(index) }}
          </vs-checkbox>
        </div>
      </div>

      <div class="employee-devices-additional-settings-popup__buttons">
        <div class="employee-devices-additional-settings-popup__button">
          <app-button type="border" @click="openNotHandOverValuesPopup">Квартиры несдающие показания</app-button>
        </div>
        <div class="employee-devices-additional-settings-popup__button">
          <app-button type="border" @click="openEndsNextCheckingDatePopup">Квартиры, у которых подходит срок поверки ИПУ
            или вышел
          </app-button>
        </div>
        <div class="employee-devices-additional-settings-popup__button">
          <app-button type="border" @click="openNotAllDevicesCommissionedPopup">Квартиры, у которых не все счетчики
            введены в экплуатацию
          </app-button>
        </div>
        <div class="employee-devices-additional-settings-popup__button">
          <app-button type="border" @click="openBigValuesPopup">
            Квартиры, сдавшие большие показания
          </app-button>
        </div>
        <div class="employee-devices-additional-settings-popup__button">
          <app-button type="border" @click="openLowerValuesPopup">
            Квартиры, сдавшие меньшие показания
          </app-button>
        </div>
      </div>
    </app-popup>
    <NotHandOverValuesPopup ref="notHandOverValuesPopup" />
    <EndsNextCheckingDatePopup ref="endsNextCheckingDatePopup" />
    <NotAllDevicesCommissionedPopup ref="notAllDevicesCommissionedPopup" />
    <BigValuesPopup ref="bigValuesPopup" />
    <LowerValuesPopup ref="lowerValuesPopup" />
  </div>
</template>

<script>
import NotHandOverValuesPopup         from "@/components/calculated-program/metering/NotHandOverValuesPopup";
import EndsNextCheckingDatePopup      from "@/components/calculated-program/metering/EndsNextCheckingDatePopup";
import NotAllDevicesCommissionedPopup from "@/components/calculated-program/metering/NotAllDevicesCommissionedPopup";
import BigValuesPopup                 from "@/components/calculated-program/metering/BigValuesPopup";
import LowerValuesPopup               from "./LowerValuesPopup";

export default {
  name:       "AdditionalSettingsPopup",
  components: {
    LowerValuesPopup,
    NotHandOverValuesPopup,
    EndsNextCheckingDatePopup,
    NotAllDevicesCommissionedPopup,
    BigValuesPopup,
  },
  props:      {
    showInactive:            {},
    columns:                 {},
    indicationColumnsFilter: {},
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed:   {
    showInactiveModel:            {
      get() {
        return this.showInactive;
      },
      set( v ) {
        this.$emit('update:showInactive', v);
      },
    },
    indicationColumnsFilterModel: {
      get() {
        return this.indicationColumnsFilter;
      },
      set( v ) {
        this.$emit('update:indicationColumnsFilter', v);
      },
    },
  },
  methods:    {
    open() {
      this.isActive = true;
    },
    findIndicationColumnByField( field ) {
      let column = this.columns.find(column => column.field === field);
      return column ? column.headerName : null;
    },
    updateColumnFilter( index, value ) {
      let filters = this.indicationColumnsFilterModel;
      filters[index] = value;
      this.indicationColumnsFilterModel = filters;
    },
    openNotHandOverValuesPopup() {
      this.$refs.notHandOverValuesPopup.open();
    },
    openEndsNextCheckingDatePopup() {
      this.$refs.endsNextCheckingDatePopup.open();
    },
    openNotAllDevicesCommissionedPopup() {
      this.$refs.notAllDevicesCommissionedPopup.open();
    },
    openBigValuesPopup() {
      this.$refs.bigValuesPopup.open();
    },
    openLowerValuesPopup() {
      this.$refs.lowerValuesPopup.open();
    },
  },
};
</script>

<style lang="scss">
.employee-devices-additional-settings-popup {
  &__show-inactive {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    &-label {
      line-height: 1.1;
    }

    &-switch {
      margin-left: .5rem;
    }

  }

  &__column-filter {
    &-title {
      margin-bottom: 15px;
      font-weight: 500;
      user-select: none;
      line-height: 1.1;
    }

    &-row {
      margin-bottom: 5px;
    }
  }

  &__buttons {
    margin-top: 30px;
  }

  &__button {
    display: block;
    margin-bottom: 10px;
    text-align: center;

    .app-button {
      display: block;
      width: 100%;
    }
  }

}
</style>
